export default __webpack_public_path__ + "images/marker.b4258770dd0ffb7455625b99f2d4c4fa.png";